// 获取cookie中的值
export function getCookie (cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim()
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

// 获取请求中的get参数
export function getUrlKey (name) {
  let val = decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  if (val == null) {
    return ''
  } else {
    return val
  }
}

// 位数不足两位补全0
function supplement (nn) {
  const ret = nn = nn < 10 ? '0' + nn : nn
  return ret
}
// 格式化时间
// 第一个参数为日期，第二个参数为年月日分割格式 '/'或'-', 第三个参数是否需要时分秒 1：需要，0不需要
// console.log(format(nowDate,'-'));// 2018-03-10 19:53:39
// console.log(format(nowDate,'/'));// 2018/03/10 19:53:39
export function formatDate (Date, str, flag = 0) {
  const obj = {
    Y: Date.getFullYear(),
    M: Date.getMonth() + 1,
    D: Date.getDate(),
    H: Date.getHours(),
    Mi: Date.getMinutes(),
    S: Date.getSeconds()
  }
  if (flag === 1) {
    // 拼接时间 hh:mm:ss
    const time = ' ' + supplement(obj.H) + ':' + supplement(obj.Mi) + ':' + supplement(obj.S)
    // yyyy-mm-dd
    if (str.indexOf('-') > -1) {
      return obj.Y + '-' + supplement(obj.M) + '-' + supplement(obj.D) + time
    }
    // yyyy/mm/dd
    if (str.indexOf('/') > -1) {
      return obj.Y + '/' + supplement(obj.M) + '/' + supplement(obj.D) + time
    }
  } else {
    // yyyy-mm-dd
    if (str.indexOf('-') > -1) {
      return obj.Y + '-' + supplement(obj.M) + '-' + supplement(obj.D)
    }
    // yyyy/mm/dd
    if (str.indexOf('/') > -1) {
      return obj.Y + '/' + supplement(obj.M) + '/' + supplement(obj.D)
    }
  }
}

export function subStrChinese(str, n) {//字符串截取 包含对中文处理
  if(typeof str == "undefined" || str == null || str == ""){
    return str;
  }
  if (str.replace(/[\u4e00-\u9fa5]/g, "**").length <= n) {
      return str;
  }
  else {
      var len = 0;
      var tmpStr = "";
      for (var i = 0; i < str.length; i++) {//遍历字符串
          if (/[\u4e00-\u9fa5]/.test(str[i])) {//中文 长度为两字节
              len += 2;
          }
          else {
              len += 1;
          }
          if (len > n) {
              break;
          }
          else {
              tmpStr += str[i];
          }
      }
      return tmpStr + "...";
  }
};
